import { fetchOrgAvailability } from 'api/targeting'
import store from 'config/store'
import { updateOnlineStatus } from 'modules/targeting/actions'
import { pathOr } from 'ramda'
import { OrgTeam } from 'types/embed'
import { warn } from 'utils'
import { memoizeUntil } from 'utils/memoizeUntil'

interface TeamAvailability {
  isOnline: boolean
}

const getMemoizedOrgAvailability = memoizeUntil(async () => {
  const { id: embedId } = store.getState().embed
  const { data: availability } = await fetchOrgAvailability(embedId)
  return availability
}, 5000)

export const getIsOnline = async () => {
  try {
    const availability = await getMemoizedOrgAvailability()
    const isOnline = pathOr(false, ['driftOnline'], availability)
    store.dispatch(updateOnlineStatus(isOnline))

    return isOnline
  } catch (err) {
    warn([`Failed to fetch online status -  ${err.message}`, err])
    return false
  }
}

export const getTeamAvailability = async (): Promise<Record<number, TeamAvailability>> => {
  try {
    const availability = await getMemoizedOrgAvailability()
    const availableTeams: number[] = availability.availableTeams || []

    const orgTeams : OrgTeam[] = pathOr([], ['configuration', 'teams'], store.getState().embed)
    const teamAvailability = {}

    orgTeams.forEach((team) => {
      const isOnline = availableTeams.includes(team.id)
      teamAvailability[team.id] = { isOnline }
    })

    return teamAvailability
  } catch (err) {
    warn(['Failed to fetch team availability', err])
    return {}
  }
}
